import { useContext, Dispatch, SetStateAction } from 'react';
import { ControllerToastSeverity } from '@bymason-private/legacy-pattern-components';
import ToastContext from '../toast-context';

export { ControllerToastSeverity } from '@bymason-private/legacy-pattern-components';

export function useToast() {
  const { setToastMessage, setToastSeverity, closeToast } = useContext(ToastContext);

  return [setToastMessage, setToastSeverity, closeToast] as [
    setToastMessage: Dispatch<SetStateAction<string>>,
    setToastSeverity: Dispatch<SetStateAction<ControllerToastSeverity | undefined>>,
    closeToast: () => void
  ];
}
